module.exports = __webpack_public_path__ + "img/DE01573.e0323608.png";